import LinkButton from 'components/LinkButton';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {H2} from 'components/Typography';
import {useBackend} from 'state/backend';
import {jt, t} from 'ttag';
import {Backend} from 'types/api';

export type RicohDirectDebitBackendData = Backend<{
    invitationLink: string;
}>;

const RicohDirectDebit = () => {
    const {
        data: {invitationLink},
    } = useBackend<RicohDirectDebitBackendData>();

    const link = (
        <a
            href="https://webform.ricoh.com/form/pub/e00156/dd-application-form"
            key={0}
            rel="opener noreferrer"
            target="_blank"
        >
            {t`this application form`}
        </a>
    );
    return (
        <>
            <NavigationTabs.Partner selection="integrations" />
            <SectionHeader
                subtitle={t`Automatically generate account transfer data from Makeleaps invoices.`}
                title={t`RICOH Direct Debit`}
            />
            <p>{t`The Bank Transfer Add-on allows you to create FB data* from invoices inside of MakeLeaps. Using FB data makes it easier to request payments via direct debit.`}</p>
            <p>{t`* A bank transfer data format of the Japanese Bankers Association`}</p>
            <p>
                {t`For further feature information or demo, please contact us at the address below.`}
                <br />
                <a
                    href="mailto:sales@makeleaps.com"
                    rel="opener noreferrer"
                    target="_blank"
                >
                    sales@makeleaps.com
                </a>
                <br />
                {jt`When applying, please fill in the required items on ${link}. (Only available in Japanese)`}
            </p>
            <H2>{t`Registered users and trial`}</H2>
            <LinkButton
                className="mb-2 mt-4"
                href={invitationLink}
                kind="primary"
                size="sm"
                target="_blank"
            >
                {t`Go to the App`}
            </LinkButton>
            <p>{t`Users that have not completed the registration can still access a restricted trial version of the feature.`}</p>
        </>
    );
};

export default RicohDirectDebit;
